import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { trim, random, startsWith } from 'lodash';
import BodyClassName from 'react-body-classname';
import Fa from 'react-fontawesome';
import Helmet from 'react-helmet';
import { Modal, Button } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';
// import styles from './login.css';
import styles from './styles.css';
import ConnectPage from '../ConnectPage/ConnectPage';
import AuthenticatePage from '../AuthenticatePage/AuthenticatePage';
import RemindPage from '../RemindPage/RemindPage';
import ResetPage from '../ResetPage/ResetPage';

// Import Selectors
import { getUser, getLoginErrors } from '../../AuthReducer';
import { getWindowWidth, getWindowHeight, getEnvironment } from '../../../App/AppReducer';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    const { location } = props;
    const query = queryString.parse(location.search);
    const { code, error, error_description } = query;
    const isReset = location.pathname === '/reset';
    let hasOpener = false;
    try {
      hasOpener = typeof window !== 'undefined' && window.opener && window.opener.loginCallback !== 'undefined';
    } catch (e) {
      hasOpener = false;
    }
    const now = moment().hour();
    const isDark = now >= 17;
    const isAfternoon = now >= 12;
    const r = random(1, 3);
    const background = `${isDark ? 'dark' : 'light'}-${r}`;
    let greeting = 'morning';

    if (isDark) {
      greeting = 'evening';
    } else if (isAfternoon) {
      greeting = 'afternoon';
    }



    this.state = {
      connecting: hasOpener || (code && !isReset),
      expand: false,
      loading: false,
      error,
      errorDescription: error_description,
      isDark,
      background,
      hideForgotPassword: false,
      greeting,
    };
    this.done = this.done.bind(this);
    this.handleLoading = this.handleLoading.bind(this);
    this.handleConnecting = this.handleConnecting.bind(this);
    this.hideForgot = this.hideForgot.bind(this);
  }

  done() {
    this.setState({ expand: false });
  }

  handleLoading(loading) {
    this.setState({ loading });
  }

  handleConnecting(connecting) {
    if (connecting) {
      this.setState({ connecting, error: null, errorDescription: null });
    } else {
      this.setState({ connecting });
    }
  }

  hideForgot(hide) {
    this.setState({ hideForgotPassword: hide });
  }

  renderTerms() {
    const { expand } = this.state;
    return (
      <Modal show={expand} onHide={this.done}>
        <Modal.Header closeButton>
          <Modal.Title>
            TruSales&trade; Terms and Conditions
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>By logging in to TruSales&trade; you agree to the following Terms and Conditions:</p>
          <p>
            You are integrating the TruSales&trade; software with your organization&rsquo;s
            licensed CRM application, and can do so with confidence that <strong>Primary
            Intelligence will keep your CRM data confidential and private</strong>.
          </p>
          <p>
            TruSales&trade; is the intellectual property of TruVoice by Corporate Visions.
            It is available for your use, subject to the subscription terms,
            so long as you use it for the benefit of your organization only,
            and commit that neither you nor your organization will attempt to
            (1) act as a re-seller of the software or otherwise profit by the promotion of TruSales&trade;
            or (2) alter, amend, copy or reverse-engineer it.
          </p>

        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" onClick={this.done}>OK</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderError(errors) {
    const message = errors !== null && errors.message ? errors.message : null;
    if (errors !== null && errors.invite_code) {
      return null; // it's ok, there is another error message display below the sf button
    }
    const apiDisabled = errors !== null && errors.errorCode === 'API_CURRENTLY_DISABLED';
    if (apiDisabled) {
      return null; // it's ok, there is another error message display below the sf button
    }
    return (
      <div>
        {message !== null && <div className={styles.actionWrapper}>
          <div className="alert alert-danger">
            <Fa name="exclamation-triangle" /> {message}
          </div>
        </div>}
      </div>
    );
  }

  renderLogin() {
    const { loading, hideForgotPassword, isDark } = this.state;
    const { location } = this.props;
    const usePassword = startsWith(location.pathname, '/signin/form');

    return (
      <div>
        {usePassword &&
          <div>
            <div className={styles.actionWrapper}>
              <AuthenticatePage isDark={isDark} location={this.props.location} hideForgot={this.hideForgot} />
            </div>
            {!hideForgotPassword && <div className={styles.forgot}><Link to="/reset">Forgot your password?</Link></div>}
          </div>
        }
        {!usePassword &&
          <div className={styles.actionWrapper}>
            <ConnectPage
              disabled={loading}
              isDark={isDark}
              onConnecting={this.handleConnecting}
              location={this.props.location}
              onLoading={this.handleLoading}
            />
          </div>
        }

        {this.state.error !== undefined && this.state.error !== null && this.renderError({ errorCode: this.state.error, message: this.state.errorDescription })}
      </div>
    );
  }

  renderResetRemind() {
    const { location } = this.props;
    const query = queryString.parse(location.search);
    const { code } = query;
    const hasCode = code !== undefined && code !== null && trim(code).length > 0;
    return (
      <div className={styles.actionWrapper}>
        {hasCode && <ResetPage location={this.props.location} />}
        {!hasCode && <RemindPage location={this.props.location} />}
      </div>
    );
  }

  renderConnectingMessage() {
    const { windowWidth, windowHeight } = this.props;
    return (
      <table
        style={{
          width: windowWidth,
          height: windowHeight,
        }}
      >
        <tbody>
          <tr>
            <td
              style={{
                textAlign: 'center',
                display: 'table-cell',
                verticalAlign: 'middle',
              }}
            >
              connecting...
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  renderCRMName() {
    // Start with Salesforce by default
    const names = ['Salesforce'];

    if (process.env.REACT_APP_AZURE_ENABLED) {
      names.push('Microsoft Dynamics');
    }
    
    if (process.env.REACT_APP_HUBSPOT_ENABLED) {
      names.push('HubSpot');
    }

    if (names.length > 1) {
      names.push(`or ${names.pop()}`);
    }

    return (names.length > 2) ? names.join(', ') : names.join(' ');
  }


  render() {
    const { connecting, isDark, background, greeting } = this.state;
    
    const {
      user, errors, location, environment, isProduction,
    } = this.props;
    const usePassword = startsWith(location.pathname, '/signin/form');
    const bgAnimateCls = (user && user._id) ? 'slideOutUp' : 'slideInDown';
    const formAnimateCls = (user && user._id) ? 'fadeOutLeft' : 'slideInLeft';
    const containerAnimateCls = (user && user._id) ? 'fadeOut' : 'fadeIn';
    const isReset = location.pathname === '/reset';

    return (
      <div className={`animated ${containerAnimateCls}`}>
        <BodyClassName className={styles.login} />
        <Helmet title="Login" />
        <div className={`${styles.wrapper} ${isDark ? styles.isDark : ''}`}>
          <div className={styles.main} style={{ backgroundImage: `url(/assets/${background}.jpg)` }}>
            <div className={styles.top}></div>
            <div className={styles.middle}>
              <div className={`panel panel-default animated ${formAnimateCls}`}>
                <div className="panel-heading">
                  <div className="panel-title text-left">
                    <img src="/assets/logo-white.png" role="presentation" className={styles.logo} />
                    {!isProduction && environment !== null && <span className="label label-warning text-uppercase">{environment}</span>}
                  </div>
                </div>
                <div className="panel-body">
                  {!isReset &&
                    <div className="text-left">
                      <p className={styles.greetings}>Good {greeting},<br /> please login to your account.</p>
                    </div>
                  }
                  {!isReset && this.renderLogin()}
                  {isReset && this.renderResetRemind()}
                </div>
              </div>

              {!isReset &&
                <p className={styles.loginSwitch}>
                  {!usePassword &&
                    <span>
                      <span className="text-warning">*</span> Not a {this.renderCRMName()} user?<br /> <Link to="/signin/form">Click here to login using username</Link>
                    </span>
                  }
                  {usePassword &&
                    <span>
                      <span className="text-warning">*</span> Using {this.renderCRMName()}?<br /> <Link to="/signin">Click here to login</Link>
                    </span>
                  }
                </p>
              }
            </div>
            <div className={styles.bottom}>
              <p>
                <span className="text-warning">*</span> By logging in to TruSales&trade;<br />
                you are agreeing to the <a href="" onClick={(e) => { e.preventDefault(); this.setState({ expand: true }); }}>Terms and Conditions</a>.
              </p>

              {process.env.REACT_APP_EMAIL_SUPPORT !== undefined && <p className={styles.assistance}>If you need assistance, please <a href={`mailto:${process.env.REACT_APP_EMAIL_SUPPORT}`}>contact us</a>.</p>}

              <div className={styles.version}>
                {!isProduction && environment !== null && <span className="text-uppercase">{environment}{': '}</span>}
                {process.env.REACT_APP_APP_VERSION !== undefined && process.env.REACT_APP_APP_VERSION}
              </div>
            </div>
          </div>
          <div className={styles.sub}>
            <div className={styles.top}></div>
            <div className={styles.middle}>
              <div className="animated slideInRight">
                <div className="animated fadeIn">
                  <h1 className={styles.welcome}>Welcome to TruSales</h1>
                  <p>TruSales is your personal win/loss dashboard and your tool for requesting feedback from buyers.</p>
                  <p>
                    If this is your first time accessing TruSales,
                    you will be asked to allow TruSales to connect to {this.renderCRMName()}.
                    You will only have to do this once.
                  </p>
                </div>
              </div>
            </div>
            <div className={styles.bottom}>
              <div className={styles.version}>
                <div className="animated fadeIn">
                  {!isProduction && environment !== null && <span className="text-uppercase">{environment}{': '}</span>}
                  {process.env.REACT_APP_APP_VERSION !== undefined && process.env.REACT_APP_APP_VERSION}
                </div>
              </div>
            </div>
          </div>
        </div>
        {connecting && this.renderConnectingMessage()}
        {this.renderTerms()}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const environment = getEnvironment();
  const isProduction = environment === 'production';
  return {
    user: getUser(state),
    errors: getLoginErrors(state),
    windowWidth: getWindowWidth(state),
    windowHeight: getWindowHeight(state),
    environment,
    isProduction,
  };
}

LoginPage.propTypes = {
  user: PropTypes.shape({
    user_id: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  errors: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
  windowWidth: PropTypes.number,
  windowHeight: PropTypes.number,
  environment: PropTypes.string,
  isProduction: PropTypes.bool,

};
LoginPage.defaultProps = {
  windowWidth: 0,
  windowHeight: 0,
  environment: null,
  isProduction: false,
};

LoginPage.contextTypes = {
  router: PropTypes.object,
};

export default withRouter(connect(mapStateToProps)(LoginPage));
